"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmlBotApplicantType = void 0;
var AmlBotApplicantType;
(function (AmlBotApplicantType) {
    AmlBotApplicantType["PERSON"] = "PERSON";
    AmlBotApplicantType["COMPANY"] = "COMPANY";
})(AmlBotApplicantType = exports.AmlBotApplicantType || (exports.AmlBotApplicantType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQW1sQm90QXBwbGljYW50VHlwZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hbWwtYm90L0FtbEJvdEFwcGxpY2FudFR5cGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsSUFBWSxtQkFHWDtBQUhELFdBQVksbUJBQW1CO0lBQzdCLHdDQUFpQixDQUFBO0lBQ2pCLDBDQUFtQixDQUFBO0FBQ3JCLENBQUMsRUFIVyxtQkFBbUIsR0FBbkIsMkJBQW1CLEtBQW5CLDJCQUFtQixRQUc5QiJ9